export default {
  reportDataRange: '报表数据范围: ',
  scanInfo: '扫描信息',
  tunnelMachine: '通道机编号',
  cartonQty: '箱数量',
  rfidQty: 'RFID数量',
  dataTransferInfo: '数据传输信息',
  api: 'API',
  noReadQty: 'No Read数量*',
  noDataQty: 'No Data数量**',
  dataMissing: '数据缺失***',
  noRead: '*No Read: 无箱号',
  noData: '** No Data: 无EPC号',
  dtMissing: '***数据缺失：指定字段数据缺失',
  abnormalTunnelStatus: '异常通道机状态>=1小时',
  abnormalTunnelStatusTab: '异常通道机状态',
  statusCode: '异常编号',
  statusMessage: '异常信息',
  abnormalTunnelHeartbeatStatus: '异常通道机心跳状态>=1小时',
  abnormalTunnelHeartbeatStatusTab: '异常心跳',
  duration: '时间段',
  byCartonByUnit: 'By Carton & By Unit',
  byCarton: 'By Carton',
  byUnit: 'By Unit',
  kpi: 'KPI',
  epcQty: 'EPC数量',
  statusCode11: '异常编号 = 11: 通道机心跳异常',
  statusCode12: '异常编号 = 12: 通道机无心跳信息',
  rfidDailyReport: 'RFID日报',
  reportTitle: '通道机异常报表',
  searchDateTitle: '日期'
}
